// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__355pf","log":"ModalInventoryLogs_log__1K0-u","date":"ModalInventoryLogs_date__1FylP","userName":"ModalInventoryLogs_userName__2TpHy"};